import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets the window scroll position to the top whenever the route changes.
 * Without this, clicking a link in the footer (which is at the bottom of
 * the page) leaves the next page scrolled to the same Y offset.
 *
 * Skips when navigation happens to a #hash anchor — those should scroll
 * to the target element, not the top.
 *
 * Mount once at the top of the app tree, inside <BrowserRouter>.
 */
const ScrollToTop = () => {
  const { pathname, hash, search } = useLocation();

  useEffect(() => {
    if (hash) return; // Let the browser handle in-page anchors
    // "instant" avoids the smooth-scroll jitter on routed navigations
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    // Some setups override that — fall back to direct property assignment
    if (document.documentElement) document.documentElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;
  }, [pathname, search, hash]);

  return null;
};

export default ScrollToTop;
